<script lang="ts" setup>
import MIcon from "../../medicus/MIcon";
import MTooltipBasic from "../../medicus/MTooltipBasic";
import { usePromise } from "vue-composable";
import { hasPermission } from "../../../utils/permission";
import { openModal } from "../../../composables/dialog/drawer";
import { useApp } from "../../../store";
import { ref, watch } from "vue";

const app = useApp();
const isOpen = ref(false);

function openSearch() {
  if (!isOpen.value) {
    isOpen.value = true;
    return openModal("/hub/patient-finder", {
      ariaLabel: "Find a patient across the hub",
      ariaLabelledBy: false,
    });
  }
}

const { loading: checkingPermission, result: hasAccess } = usePromise(() =>
  hasPermission("/hub/patient-finder"),
);

watch(
  () => app.isModalOpen,
  () => {
    isOpen.value = app.isModalOpen;
  },
);
</script>

<template>
  <m-button
    flat
    dense
    data-testid="hub-patient-finder"
    :disable="checkingPermission || !hasAccess"
    aria-haspopup="dialog"
    :aria-expanded="isOpen"
    sr-label="Find a patient across the hub"
    @click="openSearch"
  >
    <MTooltipBasic v-if="!hasAccess"
      >You don’t have permission to perform this action.</MTooltipBasic
    >
    <m-layout-stack horizontal center full>
      <m-icon name="fa-regular fa-magnifying-glass" />
      <span>Hub Patient Finder</span>
    </m-layout-stack>
  </m-button>
</template>
